export default "query attendanceTypes{\n    attendanceTypes\n}";